import { render, staticRenderFns } from "./SettingsTabGeneral.vue?vue&type=template&id=eca2b4ac&scoped=true"
import script from "./SettingsTabGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingsTabGeneral.vue?vue&type=style&index=0&id=eca2b4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca2b4ac",
  null
  
)

export default component.exports